import styled from 'styled-components'

export const MainLogoWrapper = styled.div`
  display: flex;
  height: ${props => props.height};
`